(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-mobility-landing-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const readVariants = (root) => {
      const script = root.querySelector("[data-aw40-variants]");
      if (!script) return [];
      try {
        return JSON.parse(script.textContent || "[]");
      } catch (error) {
        return [];
      }
    };

    const selectedQuantity = () => {
      const form = document.querySelector("form[action*='/cart/add']");
      const input = form ? form.querySelector("[name='quantity']") : null;
      const value = Number.parseInt(input ? input.value : "1", 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    };

    const checkoutUrl = () => "/checkout";

    const applyVariant = (root, data) => {
      if (!data) return;
      root.querySelectorAll("[data-aw40-variant-card]").forEach((card) => {
        const selected = card.getAttribute("data-aw40-variant-id") === data.id;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
      });
      document.querySelectorAll("form[action*='/cart/add'] input[name='id']").forEach((input) => {
        input.value = data.id;
      });
      root.querySelectorAll("[data-aw40-price]").forEach((node) => {
        node.textContent = data.price;
      });
      root.querySelectorAll("[data-aw40-compare]").forEach((node) => {
        if (data.compare) {
          node.textContent = data.compare;
        }
      });
      root.querySelectorAll("[data-aw40-save]").forEach((node) => {
        if (data.save) {
          node.textContent = data.save;
        }
      });
      const checkout = checkoutUrl(data);
      document.querySelectorAll("[data-aw40-submit-selected]").forEach((node) => {
        if (node.tagName === "A") {
          node.setAttribute("href", checkout);
        }
      });
      document.querySelectorAll("[data-aw40-sticky-price]").forEach((node) => {
        node.textContent = `${data.price} - review fit before ordering`;
      });
    };

    const setCheckoutReturn = (form, checkout) => {
      let input = form.querySelector("input[name='return_to'][data-aw40-return-to]");
      if (checkout) {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "return_to";
          input.setAttribute("data-aw40-return-to", "true");
          form.appendChild(input);
        }
        input.value = "/checkout";
      } else if (input) {
        input.remove();
      }
    };

    const resetCheckoutOpening = () => {
      document.documentElement.removeAttribute("data-aw40-checkout-busy");
      document.querySelectorAll("[data-aw40-submit-selected][data-aw40-idle-text]").forEach((node) => {
        node.textContent = node.getAttribute("data-aw40-idle-text") || node.textContent;
        node.removeAttribute("data-aw40-idle-text");
        node.removeAttribute("aria-busy");
      });
    };

    const markCheckoutOpening = (trigger) => {
      if (!trigger) return;
      document.documentElement.setAttribute("data-aw40-checkout-busy", "true");
      document.querySelectorAll("[data-aw40-submit-selected]").forEach((node) => {
        if (!node.getAttribute("data-aw40-idle-text")) {
          node.setAttribute("data-aw40-idle-text", node.textContent.trim() || "Checkout");
        }
        node.setAttribute("aria-busy", "true");
        node.textContent = "Opening checkout...";
      });
      window.setTimeout(resetCheckoutOpening, 8000);
    };

    const submitOfficialProductForm = (options = {}) => {
      const checkout = options.checkout === true;
      const form = document.querySelector("form[action*='/cart/add']");
      if (!form) return;
      setCheckoutReturn(form, checkout);
      if (checkout) {
        if (document.documentElement.getAttribute("data-aw40-checkout-busy") === "true") return;
        markCheckoutOpening(options.trigger);
        form.submit();
        return;
      }
      const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
      if (submitButton && !submitButton.disabled) {
        submitButton.click();
        return;
      }
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
        return;
      }
      form.submit();
    };

    const bindSticky = () => {
      const sticky = document.querySelector("[data-aw40-mobile-sticky]");
      const actions = document.querySelector(".aw40-purchase-actions");
      if (!sticky || !actions || !("IntersectionObserver" in window)) return;
      const observer = new IntersectionObserver((entries) => {
        const hide = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.12);
        sticky.classList.toggle("is-hidden", hide);
      }, { threshold: [0, .12, .4] });
      observer.observe(actions);
    };

    document.querySelectorAll("[data-aw40-panel]").forEach((root) => {
      const variants = readVariants(root);
      const byId = new Map(variants.map((item) => [item.id, item]));
      const first = variants.find((item) => item.available) || variants[0];
      root.querySelectorAll("[data-aw40-variant-card]").forEach((card) => {
        card.addEventListener("click", () => {
          const data = byId.get(card.getAttribute("data-aw40-variant-id"));
          if (!data || data.available === false) return;
          applyVariant(root, data);
        });
      });
      if (first) {
        applyVariant(root, first);
      }
    });

    if (document.documentElement.getAttribute("data-aw40-bound") !== "true") {
      document.documentElement.setAttribute("data-aw40-bound", "true");
      document.addEventListener("click", (event) => {
        const cartTrigger = event.target.closest("[data-aw40-official-add-to-cart]");
        const checkoutTrigger = event.target.closest("[data-aw40-submit-selected]");
        if (checkoutTrigger) {
          event.preventDefault();
          submitOfficialProductForm({ checkout: true, trigger: checkoutTrigger });
          return;
        }
        if (!cartTrigger) return;
        event.preventDefault();
        submitOfficialProductForm({ checkout: false, trigger: cartTrigger });
      });
      document.addEventListener("input", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches("form[action*='/cart/add'] [name='quantity']")) return;
        const root = document.querySelector("[data-aw40-panel]");
        if (!root) return;
        const variants = readVariants(root);
        const selectedInput = document.querySelector("form[action*='/cart/add'] input[name='id']");
        const data = variants.find((item) => selectedInput && item.id === selectedInput.value) || variants[0];
        applyVariant(root, data);
      });
    }

    bindSticky();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-product-conversion-flow"] && !Shopify.designMode) return;
  try {
    (() => {
    const readVariants = (root) => {
      const script = root.querySelector("[data-aw42-variants]");
      if (!script) return [];
      try {
        return JSON.parse(script.textContent || "[]");
      } catch (error) {
        return [];
      }
    };

    const selectedQuantity = () => {
      const form = document.querySelector("form[action*='/cart/add']");
      const input = form ? form.querySelector("[name='quantity']") : null;
      const value = Number.parseInt(input ? input.value : "1", 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    };

    const checkoutUrl = () => "/checkout";

    const applyVariant = (root, data) => {
      if (!data || data.available === false) return;
      root.querySelectorAll("[data-aw42-variant-card]").forEach((card) => {
        const selected = card.getAttribute("data-aw42-variant-id") === data.id;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
        const state = card.querySelector("[data-aw42-selected-state]");
        if (state) {
          if (selected) {
            state.textContent = "Selected";
          } else if (card.classList.contains("is-unavailable")) {
            state.textContent = "Unavailable";
          } else {
            state.textContent = "Choose";
          }
        }
      });
      document.querySelectorAll("form[action*='/cart/add'] input[name='id']").forEach((input) => {
        input.value = data.id;
      });
      root.querySelectorAll("[data-aw42-price]").forEach((node) => {
        node.textContent = data.price;
      });
      root.querySelectorAll("[data-aw42-compare]").forEach((node) => {
        if (data.compare) {
          node.innerHTML = `Reg. <s>${data.compare}</s>`;
        }
      });
      root.querySelectorAll("[data-aw42-save]").forEach((node) => {
        if (data.save) {
          node.textContent = `Save ${data.save}`;
        }
      });
      document.querySelectorAll("[data-aw42-direct-checkout]").forEach((node) => {
        const href = node.getAttribute("href") || "";
        if (href.includes("/pages/contact-us")) return;
        node.setAttribute("href", checkoutUrl(data));
      });
      document.querySelectorAll("[data-aw42-sticky-price]").forEach((node) => {
        node.textContent = `${data.price} - ready for checkout`;
      });
    };

    const setCheckoutReturn = (form, checkout) => {
      let input = form.querySelector("input[name='return_to'][data-aw42-return-to]");
      if (checkout) {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "return_to";
          input.setAttribute("data-aw42-return-to", "true");
          form.appendChild(input);
        }
        input.value = "/checkout";
      } else if (input) {
        input.remove();
      }
    };

    const resetCheckoutOpening = () => {
      document.documentElement.removeAttribute("data-aw42-checkout-busy");
      document.querySelectorAll("[data-aw42-direct-checkout][data-aw42-idle-text]").forEach((node) => {
        node.textContent = node.getAttribute("data-aw42-idle-text") || node.textContent;
        node.removeAttribute("data-aw42-idle-text");
        node.removeAttribute("aria-busy");
      });
    };

    const markCheckoutOpening = (trigger) => {
      if (!trigger) return;
      document.documentElement.setAttribute("data-aw42-checkout-busy", "true");
      document.querySelectorAll("[data-aw42-direct-checkout]").forEach((node) => {
        const href = node.getAttribute("href") || "";
        if (href.includes("/pages/contact-us")) return;
        if (!node.getAttribute("data-aw42-idle-text")) {
          node.setAttribute("data-aw42-idle-text", node.textContent.trim() || "Checkout");
        }
        node.setAttribute("aria-busy", "true");
        node.textContent = "Opening checkout...";
      });
      window.setTimeout(resetCheckoutOpening, 8000);
    };

    const submitOfficialProductForm = (options = {}) => {
      const checkout = options.checkout === true;
      const form = document.querySelector("form[action*='/cart/add']");
      if (!form) return;
      setCheckoutReturn(form, checkout);
      if (checkout) {
        if (document.documentElement.getAttribute("data-aw42-checkout-busy") === "true") return;
        markCheckoutOpening(options.trigger);
        form.submit();
        return;
      }
      const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
      if (submitButton && !submitButton.disabled) {
        submitButton.click();
        return;
      }
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
        return;
      }
      form.submit();
    };

    const bindSticky = () => {
      const sticky = document.querySelector("[data-aw42-sticky]");
      const actions = document.querySelector(".aw42-flow__actions");
      if (!sticky || !actions || !("IntersectionObserver" in window)) return;
      const observer = new IntersectionObserver((entries) => {
        const hide = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > .12);
        sticky.classList.toggle("is-hidden", hide);
      }, { threshold: [0, .12, .35] });
      observer.observe(actions);
    };

    document.querySelectorAll("[data-aw42-flow]").forEach((root) => {
      const variants = readVariants(root);
      const byId = new Map(variants.map((item) => [item.id, item]));
      const first = variants.find((item) => item.available) || variants[0];
      root.querySelectorAll("[data-aw42-variant-card]").forEach((card) => {
        card.addEventListener("click", () => {
          const data = byId.get(card.getAttribute("data-aw42-variant-id"));
          applyVariant(root, data);
        });
      });
      if (first) {
        applyVariant(root, first);
      }
    });

    if (document.documentElement.getAttribute("data-aw42-bound") !== "true") {
      document.documentElement.setAttribute("data-aw42-bound", "true");
      document.addEventListener("click", (event) => {
        const cartTrigger = event.target.closest("[data-aw42-official-add-to-cart]");
        const checkoutTrigger = event.target.closest("[data-aw42-direct-checkout]");
        if (checkoutTrigger) {
          const href = checkoutTrigger.getAttribute("href") || "";
          if (href.includes("/pages/contact-us")) return;
          event.preventDefault();
          submitOfficialProductForm({ checkout: true, trigger: checkoutTrigger });
          return;
        }
        if (!cartTrigger || cartTrigger.disabled) return;
        event.preventDefault();
        submitOfficialProductForm({ checkout: false, trigger: cartTrigger });
      });
      document.addEventListener("input", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches("form[action*='/cart/add'] [name='quantity']")) return;
        const root = document.querySelector("[data-aw42-flow]");
        if (!root) return;
        const variants = readVariants(root);
        const selectedInput = document.querySelector("form[action*='/cart/add'] input[name='id']");
        const data = variants.find((item) => selectedInput && item.id === selectedInput.value) || variants.find((item) => item.available) || variants[0];
        applyVariant(root, data);
      });
    }

    bindSticky();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-ys16-dual-battery-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const familyVariantIds = ["53301959426342", "53301954314534"];
    const variants = {
      "12ah": {
        variantId: "53301959426342",
        discountCode: "",
        ctaText: "Checkout - $749",
        title: "YS16-1 MAX 12Ah - $749",
        stickyTitle: "YS16-1 MAX 12Ah - $749",
        stickyMeta: "Final price before tax",
        quickTitle: "12Ah Standard - up to 9.32 mi",
        quickOffer: "$749 final price before tax.",
        dealBattery: "12Ah",
        dealRange: "9.32 mi",
        dealBadge: "Final price",
        dealCode: "$749",
        dealSavings: "$30",
        scarcity: "No coupon code step.",
        offerAmount: "$30",
        offer: "12Ah Standard: $749 final price",
        battery: "12Ah Battery",
        weight: "Approx. 103 lb",
        value: "12Ah keeps the starting price lower.",
        why: "Lower entry price for shorter routes when $749 matters more than extra reserve.",
        meta: "22.05\" seat - 397 lb capacity - Up to 9.32 mi / 15 km - Approx. 103 lb with battery."
      },
      "20ah": {
        variantId: "53301954314534",
        discountCode: "",
        ctaText: "Checkout - $809",
        title: "YS16-1 MAX 20Ah - $809",
        stickyTitle: "YS16-1 MAX 20Ah - $809",
        stickyMeta: "Final price before tax",
        quickTitle: "20Ah Extended - up to 15.5 mi",
        quickOffer: "$809 final price before tax.",
        dealBattery: "20Ah",
        dealRange: "15.5 mi",
        dealBadge: "Final price",
        dealCode: "$809",
        dealSavings: "$50",
        scarcity: "No coupon code step.",
        offerAmount: "$50",
        offer: "20Ah Extended: $809 final price",
        battery: "20Ah Battery",
        weight: "Approx. 114 lb",
        value: "20Ah adds +67% battery capacity.",
        why: "Recommended for ad shoppers who want longer outdoor trips and extra reserve.",
        meta: "22.05\" seat - 397 lb capacity - Up to 15.5 mi / 25 km - Approx. 114 lb with battery."
      }
    };

    const setText = (selector, value) => {
      document.querySelectorAll(selector).forEach((node) => {
        node.textContent = value;
      });
    };

    const syncPurchaseButtons = (data) => {
      document.querySelectorAll("[data-aw31-dual-output='cta'], .aw31-mobile-sticky a").forEach((node) => {
        if (node.textContent.trim() !== data.ctaText) {
          node.textContent = data.ctaText;
        }
        node.setAttribute("aria-label", data.ctaText);
        if (node.tagName === "A") {
          node.setAttribute("href", checkoutPermalink(data));
        }
      });
    };

    const setBattery = (battery) => {
      const data = variants[battery] || variants["20ah"];
      document.querySelectorAll("[data-aw31-battery-card]").forEach((card) => {
        const selected = card.getAttribute("data-battery") === battery;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
      });
      document.querySelectorAll("[data-aw31-visual-row]").forEach((row) => {
        row.classList.toggle("is-selected", row.getAttribute("data-aw31-visual-row") === battery);
      });
      document.querySelectorAll("form[action*='/cart/add'] input[name='id']").forEach((input) => {
        input.value = data.variantId;
      });
      setText("[data-aw31-dual-output='title']", data.title);
      setText("[data-aw31-dual-output='offer']", data.offer);
      setText("[data-aw31-dual-output='why']", data.why);
      setText("[data-aw31-dual-output='value']", data.value);
      setText("[data-aw31-dual-output='meta']", data.meta);
      setText("[data-aw31-dual-output='quickTitle']", data.quickTitle);
      setText("[data-aw31-dual-output='quickOffer']", data.quickOffer);
      setText("[data-aw31-dual-output='dealBadge']", data.dealBadge);
      setText("[data-aw31-dual-output='dealCode']", data.dealCode);
      setText("[data-aw31-dual-output='dealSavings']", data.dealSavings);
      setText(".aw31-dual-picker__scarcity", data.scarcity);
      setText("[data-aw31-dual-output='dealBattery']", data.dealBattery);
      setText("[data-aw31-dual-output='dealRange']", data.dealRange);
      setText("[data-aw31-dual-spec='battery']", data.battery);
      setText("[data-aw31-dual-spec='weight']", data.weight);
      setText(".aw31-mobile-sticky strong", data.stickyTitle);
      setText(".aw31-mobile-sticky small", data.stickyMeta);
      syncPurchaseButtons(data);
      updateCopyControls(data);
      document.documentElement.setAttribute("data-aw31-battery", battery);
      updateOfferCountdown();
    };

    const getRoutesRoot = () => {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
      return root.endsWith("/") ? root : `${root}/`;
    };

    const buildRoute = (path) => `${getRoutesRoot()}${path.replace(/^\/+/, "")}`;

    const currentBattery = () => document.documentElement.getAttribute("data-aw31-battery") || "20ah";

    const currentVariant = () => variants[currentBattery()] || variants["20ah"];

    const copyControlLabel = (button) => button.getAttribute("data-aw31-copy-label-text") || "Copy code";

    const updateCopyControls = (data) => {
      document.querySelectorAll("[data-aw31-copy-code]").forEach((button) => {
        const code = data.dealCode || data.discountCode;
        button.setAttribute("data-aw31-copy-value", code);
        button.setAttribute("aria-label", `Copy discount code ${code}`);
        const label = button.querySelector("[data-aw31-copy-label]");
        if (label && !button.classList.contains("is-copied")) {
          label.textContent = copyControlLabel(button);
        }
        const codeNode = button.querySelector("[data-aw31-copy-code-value]");
        if (codeNode) {
          codeNode.textContent = code;
        }
      });
    };

    const writeClipboardText = async (code) => {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        await navigator.clipboard.writeText(code);
        return;
      }
      const textarea = document.createElement("textarea");
      textarea.value = code;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.top = "-1000px";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      textarea.remove();
    };

    const showCopyFeedback = (button, code) => {
      button.classList.add("is-copied");
      button.setAttribute("aria-label", `Copied discount code ${code}`);
      const label = button.querySelector("[data-aw31-copy-label]");
      if (label) {
        label.textContent = "Copied";
      }
      window.clearTimeout(Number(button.dataset.aw31CopyTimer || 0));
      button.dataset.aw31CopyTimer = String(window.setTimeout(() => {
        button.classList.remove("is-copied");
        button.setAttribute("aria-label", `Copy discount code ${button.getAttribute("data-aw31-copy-value") || code}`);
        const nextLabel = button.querySelector("[data-aw31-copy-label]");
        if (nextLabel) {
          nextLabel.textContent = copyControlLabel(button);
        }
      }, 1800));
    };

    const copyDiscountCode = async (button) => {
      const code = button.getAttribute("data-aw31-copy-value") || currentVariant().dealCode;
      try {
        await writeClipboardText(code);
        showCopyFeedback(button, code);
      } catch (_error) {
        showCopyFeedback(button, code);
      }
    };

    const updateOfferCountdown = () => {
      const now = new Date();
      const ends = new Date(now);
      ends.setHours(23, 59, 59, 999);
      const diff = Math.max(0, ends.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const label = diff > 0
        ? `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        : "Ending now";
      const ariaLabel = diff > 0
        ? `Limited-time ${currentVariant().offerAmount} code ends today in ${hours} hours, ${String(minutes).padStart(2, "0")} minutes, and ${String(seconds).padStart(2, "0")} seconds`
        : `Limited-time ${currentVariant().offerAmount} code is ending now`;
      document.querySelectorAll("[data-aw31-offer-countdown], [data-aw31-card-countdown]").forEach((node) => {
        node.textContent = label;
        node.setAttribute("aria-label", ariaLabel);
      });
    };

    const selectedQuantity = () => {
      const form = document.querySelector("form[action*='/cart/add']");
      const input = form ? form.querySelector("[name='quantity']") : null;
      const value = Number.parseInt(input ? input.value : "1", 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    };

    const cartPermalink = (data = currentVariant(), checkout = false) => {
      const variant = data || currentVariant();
      const quantity = selectedQuantity();
      const params = new URLSearchParams();
      if (!checkout) {
        params.set("storefront", "true");
      }
      const query = params.toString();
      return `${buildRoute(`/cart/${encodeURIComponent(variant.variantId)}:${quantity}`)}${query ? `?${query}` : ""}`;
    };

    const checkoutPermalink = (data = currentVariant()) => cartPermalink(data, true);

    const setCheckoutReturn = (form, checkout) => {
      let input = form.querySelector("input[name='return_to'][data-aw31-return-to]");
      if (checkout) {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "return_to";
          input.setAttribute("data-aw31-return-to", "true");
          form.appendChild(input);
        }
        input.value = "/checkout";
      } else if (input) {
        input.remove();
      }
    };

    const resetCheckoutOpening = () => {
      document.documentElement.removeAttribute("data-aw31-checkout-busy");
      document.querySelectorAll("[data-aw31-submit-selected][data-aw31-idle-text]").forEach((node) => {
        node.textContent = node.getAttribute("data-aw31-idle-text") || node.textContent;
        node.removeAttribute("data-aw31-idle-text");
        node.removeAttribute("aria-busy");
      });
    };

    const markCheckoutOpening = (trigger) => {
      if (!trigger) return;
      document.documentElement.setAttribute("data-aw31-checkout-busy", "true");
      document.querySelectorAll("[data-aw31-submit-selected]").forEach((node) => {
        if (!node.getAttribute("data-aw31-idle-text")) {
          node.setAttribute("data-aw31-idle-text", node.textContent.trim() || "Checkout");
        }
        node.setAttribute("aria-busy", "true");
        node.textContent = "Opening checkout...";
      });
      window.setTimeout(resetCheckoutOpening, 8000);
    };

    const submitSelectedCheckout = (trigger) => {
      if (document.documentElement.getAttribute("data-aw31-checkout-busy") === "true") return;
      markCheckoutOpening(trigger);
      window.location.assign(checkoutPermalink(currentVariant()));
    };

    const submitSelectedCart = () => {
      if (document.documentElement.getAttribute("data-aw31-cart-busy") === "true") return;
      document.documentElement.setAttribute("data-aw31-cart-busy", "true");
      window.location.assign(cartPermalink(currentVariant(), false));
    };

    if (document.documentElement.getAttribute("data-aw31-submit-bound") !== "true") {
      document.documentElement.setAttribute("data-aw31-submit-bound", "true");
      document.addEventListener("click", (event) => {
        const copyTrigger = event.target.closest("[data-aw31-copy-code]");
        const checkoutTrigger = event.target.closest("[data-aw31-submit-selected]");
        const cartTrigger = event.target.closest("form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] input[type='submit']");
        if (!copyTrigger && !checkoutTrigger && !cartTrigger) return;
        if (copyTrigger) {
          event.preventDefault();
          event.stopPropagation();
          copyDiscountCode(copyTrigger);
          return;
        }
        if (checkoutTrigger && checkoutTrigger.tagName === "A" && checkoutTrigger.getAttribute("href")) {
          event.preventDefault();
          event.stopPropagation();
          submitSelectedCheckout(checkoutTrigger);
          return;
        }
        if (cartTrigger && /add to cart/i.test(cartTrigger.textContent || cartTrigger.value || "")) {
          event.preventDefault();
          event.stopPropagation();
          submitSelectedCart();
          return;
        }
      }, true);
      document.addEventListener("input", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches("form[action*='/cart/add'] [name='quantity']")) return;
        syncPurchaseButtons(currentVariant());
      });
      document.addEventListener("change", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches("form[action*='/cart/add'] [name='quantity']")) return;
        syncPurchaseButtons(currentVariant());
      });
      window.addEventListener("pageshow", resetCheckoutOpening);
    }

    document.querySelectorAll("[data-aw31-dual-picker]").forEach((root) => {
      const initial = root.getAttribute("data-aw31-default-battery") || "20ah";
      root.querySelectorAll("[data-aw31-battery-card]").forEach((card) => {
        card.addEventListener("click", () => setBattery(card.getAttribute("data-battery")));
        card.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          setBattery(card.getAttribute("data-battery"));
        });
      });
      setBattery(initial);
    });
    if (document.documentElement.getAttribute("data-aw31-offer-countdown-bound") !== "true") {
      document.documentElement.setAttribute("data-aw31-offer-countdown-bound", "true");
      updateOfferCountdown();
      window.setInterval(updateOfferCountdown, 1000);
    } else {
      updateOfferCountdown();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
